import { render, staticRenderFns } from "./payment_channel_selector.vue?vue&type=template&id=6976afd1"
import script from "./payment_channel_selector.vue?vue&type=script&lang=js"
export * from "./payment_channel_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports